import React from 'react';
import { useNavigate } from 'react-router-dom';
import CurrentDateTime from "../CurrentDateTime";

function ConfirmScreen() {
  const navigate = useNavigate();

  return (
    <>

      <section
        className="d-table w-100"
        id=""
        style={{
          backgroundImage: `url(/assets/images/bookonline-bg.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          backgroundAttachment: 'fixed',
          paddingTop: '10px'
        }}
      >
        <CurrentDateTime />
        <div className="container">
          <div className="row justify-content-center mt-5">
            <div className="col-md-5"></div>
            <div className="col-12 col-md-7">
              <div className="card rounded text-center" style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: '1px solid #424242',
                boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
              }}>
                <h1 className="sub-title mb-2 mt-5 text-black" style={{ fontSize: "25px" }}>Appointment Cancelled Successfully</h1>
                <p className="para-desc mx-auto text-black">
                  We hope to see you again soon.
                </p>
                <p className="para-desc mx-auto" style={{ color: "#396cf0" }}>
                  If you have any questions, please feel free to contact us.
                </p>
                <div className="d-flex justify-content-center">
                  <button
                    className="btn btn-primary mt-4 mb-5"
                    onClick={() => navigate('/online-appointment')}
                  >
                    Go to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default ConfirmScreen;